module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewOfferLetter"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.printOfferLetter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printOfferLetter"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [(_vm.seeRecord) ? _c('div', {
    staticClass: "card-body box-profile"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('td', {
    attrs: {
      "width": "18%"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "height": "90",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.getCompanyRecord.address) + ", " + _vm._s(_vm.getCompanyRecord.city) + ", " + _vm._s(_vm.getCompanyRecord.state) + " - " + _vm._s(_vm.getCompanyRecord.pin) + "\n                        "), _c('br'), _vm._v("CIN : " + _vm._s(_vm.getCompanyRecord.cin) + ", Website - " + _vm._s(_vm.getCompanyRecord.url) + ", Mobile No - " + _vm._s(_vm.getCompanyRecord.phone) + ", Email ID - " + _vm._s(_vm.getCompanyRecord.email) + "\n                        ")]), _c('br'), _c('br'), _c('strong', [_vm._v("Letter Of Offer")])])]), _vm._v(" "), (_vm.seeRecord.user) ? _c('td', {
    staticClass: "text-right",
    attrs: {
      "width": "20%"
    }
  }, [_c('barcode', {
    attrs: {
      "value": _vm.seeRecord.user.code,
      "height": "45",
      "width": "1"
    }
  }, [_vm._v("\n                          Show this if the rendering fails.\n                        ")])], 1) : _vm._e()])]), _vm._v(" "), _c('hr', {
    attrs: {
      "width": "100%"
    }
  }), _vm._v(" "), (_vm.seeRecord.user) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('td', [_c('b', [_vm._v("\n                          " + _vm._s(_vm.seeRecord.user.name) + " "), _c('br'), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.seeRecord.address) + ",")]), _c('br'), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.seeRecord.city) + ",")]), (_vm.seeRecord.state) ? _c('i', [_vm._v(_vm._s(_vm.seeRecord.state.name) + " -")]) : _vm._e(), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.seeRecord.pin))]), _c('br')])]), _vm._v(" "), (_vm.seeRecord.branch) ? _c('td', {
    staticClass: "text-right"
  }, [_vm._v("Branch: " + _vm._s(_vm.seeRecord.branch.name) + " "), _c('br'), _vm._v("Date: " + _vm._s(_vm._f("myDate")(_vm.currDate)))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "text-center text-bold"
  }, [_vm._v("Sub: Job Offer")]), _vm._v(" "), _c('p', [_vm._v("Dear "), (_vm.seeRecord.user) ? _c('b', [_vm._v(_vm._s(_vm.seeRecord.user.name))]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("We are pleased to offer you the position of "), (_vm.seeRecord.designation) ? _c('b', [_vm._v(_vm._s(_vm.seeRecord.designation.name))]) : _vm._e(), _vm._v(" in our Company "), _c('b', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _vm._v(" based at "), _c('i', [_vm._v(_vm._s(_vm.getCompanyRecord.address) + ",")]), _vm._v(" "), (_vm.seeRecord.state) ? _c('i', [_vm._v(_vm._s(_vm.seeRecord.state.name) + " -")]) : _vm._e(), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.seeRecord.pin))]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Your immediate supervisor will be " + _vm._s(_vm.reportingmanager) + ". We trust that your knowledge, skills and experience will be among our most valuable assets.")]), _vm._v(" "), _c('p', [_vm._v("As discussed and agreed with you, you will be eligible to receive the following beginning on your joining date:")]), _vm._v(" "), _c('ul', [_c('li', [_c('b', [_vm._v("Salary:")]), _vm._v(" Annual gross starting salary of Rs." + _vm._s(_vm.annualctc) + ", subject to tax and other statutory deductions")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_vm._v("Business Travel allowance and reimbursements as per company policy.")])]), _vm._v(" "), _c('p', [_vm._v("This offer letter is valid till " + _vm._s(_vm._f("myDate")(_vm.seeRecord.joiningDate)) + ".  Please send a signed copy of this letter indicating your acceptance to join and resignation acceptance letter from your current employer to our HR.")]), _vm._v(" "), _c('p', [_vm._v("Your Appointment Letter will be issued on the date of joining. The joining formalities and induction will be carried out in our " + _vm._s(_vm.getCompanyRecord.address) + " office.")]), _vm._v(" "), _c('p', [_vm._v("Please submit the following documents to HR at the time of your joining:  ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("We look forward to welcome you aboard.")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("Sincerely, ")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("For "), _c('b', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))])]), _vm._v(" "), _c('p', [_vm._v("HR DEPARTMENT")]), _vm._v(" "), _c('p', [_vm._v("Date: ")]), _vm._v(" "), _c('p', [_vm._v("Location: ")])]) : _vm._e()])])])]), _vm._v(" "), _vm._m(3)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('b', [_vm._v("Sales Incentive:")]), _vm._v(" As per the prevailing company scheme (Only Applicable for Sales personnel)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                    (1) photocopies of your degree certificates,"), _c('br'), _vm._v("\n                    (2) certifications, if any, "), _c('br'), _vm._v("\n                    (3) experience/ relieving letters"), _c('br'), _vm._v("\n                    (4) two color passport-size photos, "), _c('br'), _vm._v("\n                    (5) latest salary slips from your previous organization and "), _c('br'), _vm._v("\n                    (6) proof of address.\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            CLOSE\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a492fc2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/components/OfferLetter.vue
// module id = 781
// module chunks = 0